var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRampLogo = function SvgRampLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.332 19.09l-3.247 3.26a.71.71 0 000 1l2.482 2.484a1.1 1.1 0 001.537 0l7.604-7.505c.423-.418.423-1.1 0-1.517l-7.604-7.499a1.1 1.1 0 00-1.537 0l-2.481 2.485a.71.71 0 00-.001 1l3.247 3.259c.845.834.845 2.199 0 3.034z",
    fill: "#0A6E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.568 19.09l3.247 3.26a.71.71 0 010 1l-2.482 2.484a1.1 1.1 0 01-1.537 0L5.192 18.33a1.066 1.066 0 010-1.517l7.604-7.499a1.1 1.1 0 011.537 0l2.481 2.485a.71.71 0 010 1l-3.246 3.259a2.131 2.131 0 000 3.034z",
    fill: "#21BF73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.42 18.194a.877.877 0 010-1.24l3.41-3.41a.877.877 0 011.24 0l3.41 3.41a.877.877 0 010 1.24l-3.41 3.41a.877.877 0 01-1.24 0l-3.41-3.41z",
    fill: "#21BF73"
  })));
};
export default SvgRampLogo;